export default __webpack_public_path__ + "static/media/home.b78e57d3.png";